(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.StatusController = (function(superClass) {
    extend(StatusController, superClass);

    function StatusController(scope, transitions, state, modal, mcs, loader) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.modal = modal;
      this.mcs = mcs;
      this.loader = loader;
      this.close = bind(this.close, this);
      this.handleRowClick = bind(this.handleRowClick, this);
      this.clearSingle = bind(this.clearSingle, this);
      this.bulkClearSelectAll = bind(this.bulkClearSelectAll, this);
      this.handleBulkClear = bind(this.handleBulkClear, this);
      this.bulkClear = bind(this.bulkClear, this);
      this.cancelBulkClear = bind(this.cancelBulkClear, this);
      this.colorStatus = bind(this.colorStatus, this);
      StatusController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.$emit('data_fullpage:hide');
      setTimeout((function(_this) {
        return function() {
          _this.scope.$emit('data_fullpage:show');
          return $(window).trigger('resize');
        };
      })(this), 500);
      this.loader.overMap('Loading...');
      this.scope.mcs = this.mcs;
      this.scope.clear_selections = [];
      this.scope.cant_clear = ['Uploading', 'Processing', 'Converted'];
      this.scope.bulkClearing = false;
      this.scope.selectedAll = false;
      this.scope.clearBtnText = 'Bulk Clear';
      this.scope.selectBtnText = 'Select All';
      this.scope.close = this.close;
      this.scope.colorStatus = this.colorStatus;
      this.scope.bulkClear = this.bulkClear;
      this.scope.bulkClearSelectAll = this.bulkClearSelectAll;
      this.scope.handleRowClick = this.handleRowClick;
      this.scope.clearSingle = this.clearSingle;
      this.scope.updateFiles = this.updateFiles;
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          if ($transition.to().url !== '/confirmation') {
            return _this.scope.$emit('data_fullpage:hide');
          }
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          _this.cancelBulkClear();
          return _this.transitionStart();
        };
      })(this));
      $(window).on('resize', debounce((function(_this) {
        return function() {
          return _this.loader.hideAll();
        };
      })(this)));
    }

    StatusController.prototype.colorStatus = function(status) {
      switch (status) {
        case 'Uploading':
        case 'Processing':
          return 'text-blue';
        case 'Success':
          return 'text-green';
        case 'Converted':
          return 'text-orange';
        default:
          return 'text-red';
      }
    };

    StatusController.prototype.cancelBulkClear = function() {
      this.scope.clear_selections = [];
      this.scope.bulkClearing = true;
      return this.bulkClear();
    };

    StatusController.prototype.bulkClear = function() {
      var file, i, len, ref, results;
      if (this.scope.clear_selections.length > 0) {
        return this.handleBulkClear();
      } else {
        this.scope.bulkClearing = !this.scope.bulkClearing;
        this.scope.selectedAll = !this.scope.bulkClearing ? false : void 0;
        this.scope.clearBtnText = this.scope.bulkClearing ? 'Cancel Clear' : 'Bulk Clear';
        if (this.mcs.input_files != null) {
          ref = this.mcs.input_files;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            file = ref[i];
            if (this.scope.cant_clear.indexOf(file.status) === -1 && this.scope.bulkClearing) {
              results.push(file.rowClass = 'multidelete alert-success');
            } else {
              results.push(file.rowClass = '');
            }
          }
          return results;
        }
      }
    };

    StatusController.prototype.handleBulkClear = function() {
      var file, file_ids, i, len, msg, ref;
      msg = this.loader.overMap('Loading...');
      file_ids = [];
      ref = this.scope.clear_selections;
      for (i = 0, len = ref.length; i < len; i++) {
        file = ref[i];
        file_ids.push(file.id);
        this.mcs.clearFile(file);
      }
      this.mcs.clearDbInputFiles(file_ids);
      this.scope.clear_selections = [];
      this.bulkClear();
      $(window).trigger('resize');
      return true;
    };

    StatusController.prototype.bulkClearSelectAll = function() {
      var file, i, len, ref, results;
      this.scope.selectedAll = !this.scope.selectedAll;
      this.scope.clearBtnText = this.scope.selectedAll ? 'Clear Selected' : 'Cancel Clear';
      this.scope.clear_selections = [];
      ref = this.mcs.input_files;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        file = ref[i];
        file.canClear = this.scope.cant_clear.indexOf(file.status) === -1;
        if (file.canClear) {
          if (this.scope.selectedAll) {
            file.rowClass = 'multidelete alert-error';
            results.push(this.scope.clear_selections.push(file));
          } else {
            results.push(file.rowClass = 'multidelete alert-success');
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    StatusController.prototype.clearSingle = function(file) {
      var msg;
      msg = this.loader.overMap('Loading...');
      this.mcs.clearFile(file);
      this.mcs.clearDbInputFiles([file.id]);
      $(window).trigger('resize');
      return true;
    };

    StatusController.prototype.handleRowClick = function(file) {
      var index;
      if (!this.scope.bulkClearing) {
        return;
      }
      if (file.rowClass === 'multidelete alert-success') {
        file.rowClass = 'multidelete alert-error';
        this.scope.clear_selections.push(file);
      } else if (file.rowClass === 'multidelete alert-error') {
        file.rowClass = 'multidelete alert-success';
        index = this.scope.clear_selections.indexOf(file);
        this.scope.clear_selections.splice(index, 1);
      }
      return this.scope.clearBtnText = this.scope.clear_selections.length > 0 ? 'Clear Selected' : 'Cancel Clear';
    };

    StatusController.prototype.close = function() {
      return this.state.go('grower.data.add');
    };

    return StatusController;

  })(Controller);

}).call(this);
